import type {
  TypeArticleWithoutUnresolvableLinksResponse,
  TypeEventWithoutUnresolvableLinksResponse,
  TypePageBuilderWithoutUnresolvableLinksResponse,
} from '~/types/contentful'

export default defineNuxtPlugin(() => {
  const checkVisibility = (
    entry:
      | TypeArticleWithoutUnresolvableLinksResponse
      | TypeEventWithoutUnresolvableLinksResponse
      | TypePageBuilderWithoutUnresolvableLinksResponse
      | undefined,
    redirectUrl: string | undefined = '/',
    debug: boolean = false,
  ): true | 'unknown' | Promise<void> => {
    const { $visibilityDecision, $i18n } = useNuxtApp()
    const { locale } = $i18n
    const decision = $visibilityDecision(entry?.fields?.visibility)

    if (debug) {
      console.log(
        `[checkVisibility] visibility check result for entry with id ${
          entry?.sys.id ?? 'undefined'
        }:`,
        decision,
      )
    }

    // Not enough info (e.g. country cookie missing)
    if (decision.visible === null) return 'unknown'

    if (decision.visible === false) {
      if (debug) {
        console.warn(
          `[checkVisibility] entry with id ${
            entry?.sys.id ?? 'undefined'
          } failed visibility test (reasons: ${decision.reasons.join(
            ', ',
          )}), redirecting to ${redirectUrl}`,
        )
        return Promise.resolve()
      } else {
        const router = useRouter()
        return router.push(`/${locale.value}${redirectUrl}`).then(() => {})
      }
    }

    return true
  }

  return {
    provide: {
      checkVisibility,
    },
  }
})
